<!-- @format -->
	<button
		hmf-button
		variant="primary"
		id="pdp-see-available-stores-button"
		name="pdp-see-available-stores-button"
		class="hmf-w-100 hmf-h-100 hmf-flex-grow hmf-m-0 hmf-p-0 hmf-sharp-radius"
		type="submit"
		[disabled]="isErrorOnAttributes"
		[text]="atcButtonTexts.nearbyStores"
		(click)="openChangeStorePanel()"></button>
